var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage1VideoCoverList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 361 265",
    style: {
      enableBackground: "new 0 0 361 265"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.56;fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.42;fill:#FFFFFF;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.871,
    y1: -36.1514,
    x2: 83.1384,
    y2: 301.1351,
    gradientTransform: "matrix(1 0 0 -1 0 265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7BB1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.4,264.8H27.6c-15.3,0-27.9-12.6-27.9-27.9V28.1c0-15.3,12.6-27.9,27.9-27.9h305.8 c15.3,0,27.9,12.6,27.9,27.9v208.8C361.3,252.3,348.7,264.8,333.4,264.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.1,50.2c-81-34.7-158.3,42.6-123.6,123.6c8.3,19.4,23.9,35,43.3,43.3c81,34.7,158.3-42.6,123.6-123.6 C257.1,74.1,241.6,58.5,222.1,50.2z M182,203.2c-39.4,0-71.4-32-71.4-71.4s32-71.4,71.4-71.4s71.4,32,71.4,71.4 S221.5,203.2,182,203.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.9,121.8l-43.3-25c-7.5-4.3-16.8,1.1-16.8,9.7v50c0,8.6,9.4,14,16.8,9.7l43.3-25 C221.4,136.9,221.4,126.1,213.9,121.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1VideoCoverList);
export default __webpack_public_path__ + "static/media/stage1_videoCover_list.a946c0bb1b4a9ac83085d25c076cf1cf.svg";
export { ForwardRef as ReactComponent };